/* GSI PLP card colorway swatches — click a dot to swap the card image to that variant and
   point the card links at it. Event-delegated so it also covers cards loaded via filtering/paging.
   Markup: snippets/card-product.liquid (.gsi-card-swatch[data-gsi-swatch]). */
(function () {
  /* Shared, lazily-created polite live region so a swatch swap is announced to screen readers. */
  function announce(msg) {
    if (!msg) return;
    var live = document.getElementById('gsi-swatch-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'gsi-swatch-live';
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = msg;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gsi-swatch]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('.card-wrapper');
    if (!card) return;
    var img = btn.getAttribute('data-img');
    var url = btn.getAttribute('data-url');

    var slides = card.querySelectorAll('.gsi-cardmedia__slide');
    if (slides.length) {
      /* multi-image slider card: repoint the first slide to the variant image and show it */
      var im = slides[0].querySelector('img');
      if (im && img) { im.removeAttribute('srcset'); im.setAttribute('src', img); }
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === 0);
        if (url) slides[i].setAttribute('href', url);
      }
      var dots = card.querySelectorAll('.gsi-cardmedia__dots [data-gsi-dot]');
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === 0);
        if (d === 0) dots[d].setAttribute('aria-current', 'true');
        else dots[d].removeAttribute('aria-current');
      }
    } else {
      /* single-image card */
      var main = card.querySelector('.card__media img');
      if (main && img) { main.removeAttribute('srcset'); main.setAttribute('src', img); }
    }

    var titleLink = card.querySelector('.card__heading a');
    if (titleLink && url) titleLink.setAttribute('href', url);

    var swatches = card.querySelectorAll('[data-gsi-swatch]');
    for (var s = 0; s < swatches.length; s++) {
      var on = swatches[s] === btn;
      swatches[s].classList.toggle('is-active', on);
      swatches[s].setAttribute('aria-pressed', on ? 'true' : 'false'); // a11y 4.1.2: reflect the pressed state
    }

    announce(btn.getAttribute('aria-label')); // e.g. "Blue" — read out on swap
  });
})();
